import {handleReadBase64} from '@/utils/filepond';
import {ProgressServerConfigFunction} from 'filepond';

export const base64Config = (name = 'default', callback: (arg1: any, arg2: any, arg3?: any) => void = null, callback2: (arg1: any, arg2: any) => void = null) => {
	return {
		process: (fieldName: string, file: any, metadata: {[key: string]: any}, load: (p: string | {[key: string]: any}) => void, error: (errorText: string) => void, progress: ProgressServerConfigFunction, abort: () => void) => {
			console.log(file);

			// leer el xml file
			const fileBase64: any = handleReadBase64(file);

			// esperar a la promise
			fileBase64.then((result: any) => {
				// if error
				console.log('onproccess result', result);

				// set the progress
				progress(true, 100, 100);

				load(result); // set fake upload completed

				// call callback
				if (callback) callback(result, name, file.name);

				if (callback2) callback2(result, name);
			});

			// Should expose an abort method so the request can be cancelled
			return {
				abort: () => {
					// Let FilePond know the request has been cancelled
					abort();
				},
			};
		},
		revert: '',
		restore: '',
		load: '',
		fetch: '',
		remove: '',
	};
};

export const urlConfig = (mainUrl: string, onServerError: any, onServerData: any) => {
	return {
		url: mainUrl,
		process: {
			url: '',
			method: 'POST',
			onerror: onServerError,
			withCredentials: false,
			ondata: onServerData,
		},
		revert: '',
		restore: '',
		load: '',
		fetch: '',
		remove: '',
	};
};
